import React from 'react';
interface SelectOption {
  value: string;
  label: string;
}
interface SelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'onChange'> {
  label: string;
  options: SelectOption[];
  error?: string;
  onChange: (value: string) => void;
}
export function Select({
  label,
  options,
  error,
  className = '',
  required,
  onChange,
  ...props
}: SelectProps) {
  return <div className="w-full" data-id="element-51">
      <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-52">
        {label}
        {required && <span className="text-red-500 ml-1" data-id="element-53">*</span>}
      </label>
      <select className={`w-full px-3 py-2 border rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-shadow ${error ? 'border-red-300 focus:ring-red-500' : 'border-gray-300'} ${className}`} onChange={e => onChange(e.target.value)} required={required} {...props} data-id="element-54">
        <option value="" data-id="element-55">Select an option</option>
        {options.map(option => <option key={option.value} value={option.value} data-id="element-56">
            {option.label}
          </option>)}
      </select>
      {error && <p className="mt-1.5 text-sm text-red-600" role="alert" data-id="element-57">
          {error}
        </p>}
    </div>;
}